import styled from "styled-components";

export const GraphsWrapper = styled.div`
  display: flex;
  flex: 1;
`;
export const GraphContainerLeft = styled.div`
  margin-left: 0.8rem;
  flex: 1;
`;
export const GraphContainerRight = styled.div`
  margin-right: 0.8rem;
  flex: 1;
`;
